/**
 * 「区域概览」数据接入（外部大屏接口，文档见 src/docs/external-area-overview-cockpit-api.md）：
 *   GET {base}/cockpit/external/areaOverview?areaId=xxx
 * 接口免登录（/cockpit/external/** 已开放），返回区域名称/介绍、经营情况、
 * 昨日客流、商户入驻（rented/vacant）与经营品类（businessScopes）。
 *
 * 跨域说明：开发环境走 vue.config.js 的 devServer.proxy（/prod-api -> sjq-cockpit 主机）；
 * 生产环境默认同域反代 /prod-api，若需直连域名，用环境变量 VUE_APP_AREA_API_BASE
 * 覆盖为完整地址（如 http://sjq-cockpit.khwlkj.com.cn/prod-api，需接口侧放开 CORS）。
 */
const API_BASE = process.env.VUE_APP_AREA_API_BASE || '/prod-api'

/**
 * 建筑标牌名（buildingNames.js 的右值）-> 区域ID。
 * 来源：src/docs/市场对应区域id.xls。其中四个名称与标牌不一致，此处按标牌名对齐：
 *   苏杭首站            = xls「苏杭首站女装广场」
 *   旺田·精品女装市场   = xls「旺田·四季青精品女装」
 *   杭州四季青面料市场  = xls「四季青面料市场」
 *   四季青服装市场      = xls「杭州四季青服装市场」
 * 标牌名在表里找不到时（新增楼未配区域ID）面板显示占位，不发请求。
 */
export const AREA_ID_BY_BUILDING = {
  '尚城女装中心': '1007',
  '新九天女装大厦': '1003',
  '苏杭首站': '1017',
  '旺田·精品女装市场': '1008',
  '维众精品汇': '1018',
  '保太和饰品区': '1019',
  '新意法女装大厦': '1009',
  '杭州四季青面料市场': '1020',
  '小白楼': '1021',
  '意法清江服装城': '1010',
  '中洲女装城': '1011',
  '四季青服装市场': '1012',
  '中纺中心服装城': '1001',
  '杭州意法服饰城': '1002',
  '新中洲女装城': '1005',
  '杭派精品服装市场': '1022',
  '爱尚潮品汇': '1023',
  'T9青年引力场': '1013',
  '昆龙童装城': '1014',
  '四季青精品童装市场': '1015',
  '常青休闲女装市场': '1004',
  '杭泵精品男装市场': '1016',
  '佳宝原创设计师女装': '1006',
}

/**
 * 按区域ID拉取区域概览。
 * 成功返回 data 对象；区域不存在时接口 code=200 且 data=null（由调用方兜底展示）；
 * HTTP 异常或业务 code 非 200 时抛错（调用方显示占位文案）。
 */
export async function fetchAreaOverview(areaId) {
  const res = await fetch(`${API_BASE}/cockpit/external/areaOverview?areaId=${encodeURIComponent(areaId)}`)
  if (!res.ok) throw new Error(`areaOverview HTTP ${res.status}`)
  const json = await res.json()
  if (json.code !== 200) throw new Error(json.msg || '区域概览接口返回异常')
  return json.data
}
